import Vue from 'vue';
import {screenH} from './os' 
Vue.directive("head100",{
    bind:(el)=>{
        // el.style.height=screenH+'px';
        Vue.prototype.$jquery(el).css("height",screenH+'px')
    }
});

Vue.filter("fixed2",function(val){
    return val.toFixed(2);
});

Vue.directive("showohide",{
    bind:(el,binding)=>{
        el.onclick=()=>{
            binding.value=!binding.value;
        }
    }
});



Vue.directive("gowhere",{
    bind:(el,binding)=>{
        el.onclick=()=>{
          //  alert('点击');
            //binding.value=!binding.value;
            binding.value.router.push( binding.value.urls)
        }
    }
});

Vue.directive("goWhereByName",{
    bind:(el,binding)=>{
        el.onclick=()=>{
          //  alert('点击');
            //binding.value=!binding.value;
            binding.value.router.push( binding.value)
        }
    }
});

Vue.filter('last18',(value)=>{
    return value.slice(0,18)+'..'
})
Vue.filter('last12',(value)=>{
    return value.slice(0,12)
})
Vue.filter('last10',(value)=>{
    return value.slice(0,10)+'...'
})
Vue.filter('last10nod',(value)=>{
    return value.slice(0,10)
})


// WEBPACK FOOTER //
// ./src/util/directive.js